import React from 'react';

import { Box, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

import {
  calloutSectionStyles,
  progressTextGroupStyles,
  widgetStyles,
} from '../PathToSubmission.styles';
import { PathToSubmissionTestIds } from '../PathToSubmission.testIds';
import PathToSubmissionHeader from '../PathToSubmissionHeader';

import {
  progressBarSkeletonStyles,
  railSkeletonStyles,
  stepSkeletonGroupStyles,
} from './PathToSubmissionSkeleton.styles';

// The channel already resolved, so the header, the step COUNT and the step ORDER are known and
// final here — only the per-step statuses and the progress figure are still in flight. Rendering
// the real frame with placeholders in exactly those slots keeps the layout from reflowing and the
// rail from reshuffling when the signals land.
const PathToSubmissionSkeleton = ({ steps, subtitle }) => (
  <Box data-testid={PathToSubmissionTestIds.LOADING_SKELETON} sx={widgetStyles}>
    <PathToSubmissionHeader subtitle={subtitle}>
      <Box sx={progressTextGroupStyles}>
        <Skeleton height={16} variant="text" width={104} />
        <Skeleton height={6} sx={progressBarSkeletonStyles} variant="rounded" width={148} />
      </Box>
    </PathToSubmissionHeader>

    <Box sx={railSkeletonStyles}>
      {steps.map(step => (
        <Box key={step.key} sx={stepSkeletonGroupStyles}>
          <Skeleton height={28} variant="circular" width={28} />
          <Skeleton height={12} variant="text" width="70%" />
        </Box>
      ))}
    </Box>

    <Box sx={calloutSectionStyles}>
      <Skeleton height={72} variant="rounded" />
    </Box>
  </Box>
);

PathToSubmissionSkeleton.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired })).isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default PathToSubmissionSkeleton;
